@if (jobStatusStatWidget) {
    <div class="grid">

        <div class="col-6">

            <mvs-widget
                    [widgetData]="jobStatusStatWidget"
                    (onObjectSelect)="handleObjectSelect($event)"
            ></mvs-widget>
        </div>
        <div class="col-6">
            @if (selectedInstance) {
                <jb-job-instance-details
                        [jobInstanceId]="selectedInstance"
                ></jb-job-instance-details>
            }
        </div>
    </div>


}
